const BRIDGE_BASE_URL = '/apps/apibridge/integration/path/';

const HC_API = {
    GET_INSTALLMENT: "/apps/holly-payments/payment/installment-plans",
};


function getBodyFromApiBridgeResponse(response) {
    try {
        if(response && response.data){
            if(response.data.status === 200 && response.data.body) {
                const responseBody = response.data.body;
                const responseBodyJson = JSON.parse(responseBody);
                return responseBodyJson;
            } else if(response.data.status === 404) {
                return response.data;
            }
        }
        return null;
    } catch (error) {
        return null;
    }
}

